import { graphql } from "../gql";

export const resetAskAutodorSavedPromptMutationDoc = graphql(`
  mutation resetAskAutodorSavedPrompt(
    $input: AskAutodorSavedPromptsNewTagsInput!
  ) {
    askAutodorResetSavedPromptTags(input: $input)
  }
`);
